import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const sendMailSlice = createSlice({
  name: 'sendMail',
  initialState: {
    email: '',
    loading:false,
    show: false,
 
  },
  reducers: {
    setEmailRedux: (state, action) => {
      const { email } = action.payload
      state.email = email
    },
    setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setShowRedux: (state, action) => {
        const { show } = action.payload
        state.show = show
      },
  },
})

export default sendMailSlice.reducer;

export const {
    setEmailRedux,
    setLoadingRedux,
    setShowRedux
  
} = sendMailSlice.actions

export const getEmailRedux = (state) => state.sendMail.email
export const getLoadingRedux = (state) => state.sendMail.loading
export const getShowRedux = (state) => state.sendMail.show
